module.exports = __webpack_public_path__ + "7a58408aecbcf7fce7a57528827f388f.png";